/**
 * Personel profil fotoğrafı servisi.
 *
 * Storage path: personelFotograflari/{personelId} (uzantısız, üzerine yazılır)
 * Firestore: kullanicilar/{personelId}.profilFotoUrl
 */

import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage'
import { doc, updateDoc, deleteField } from 'firebase/firestore'
import { getFirebaseStorage, getFirestoreDb } from '@/lib/firebase'

export async function profilFotoYukle(
  personelId: string,
  dosya: File
): Promise<string> {
  if (dosya.size > 5 * 1024 * 1024) {
    throw new Error('Fotoğraf 5 MB\'dan büyük olamaz')
  }
  if (!dosya.type.startsWith('image/')) {
    throw new Error('Sadece resim dosyası kabul edilir')
  }

  const storage = getFirebaseStorage()
  const path = `personelFotograflari/${personelId}`
  const fileRef = ref(storage, path)
  await uploadBytes(fileRef, dosya, { contentType: dosya.type })
  const url = await getDownloadURL(fileRef)

  const db = getFirestoreDb()
  await updateDoc(doc(db, 'kullanicilar', personelId), { profilFotoUrl: url })

  return url
}

export async function profilFotoSil(personelId: string): Promise<void> {
  const storage = getFirebaseStorage()
  const path = `personelFotograflari/${personelId}`
  try {
    await deleteObject(ref(storage, path))
  } catch (err) {
    console.warn('Storage silme:', err)
  }
  const db = getFirestoreDb()
  await updateDoc(doc(db, 'kullanicilar', personelId), {
    profilFotoUrl: deleteField(),
  })
}
